import { Box, Heading, Input, Button, Flex, Image, Text, Link } from "@chakra-ui/react";



export function ApplicationSummary() {
    return <Box marginTop="20px"  w="30%" h="200px" boxShadow="lg"  >



        <Text fontSize="lg" fontWeight="bold" align="left" ml="10px" h="40px" mt="15px">Application Summary</Text>
        <hr />

        <Text fontSize="md" mt="40px">Daily Limit of Application: 50</Text>




    </Box>
} 